export const config = {
  title: "Jenc Quality Pro Painting LLC",
  meta: {
    description:
      "Jenc Quality Pro Painting LLC provides exceptional residential and commercial painting services in North Carolina and Delaware. Specializing in interior and exterior projects with quality craftsmanship.",
    keywords: [
      "Painting Services North Carolina",
      "Delaware Professional Painting",
      "Interior Painting Durham NC",
      "Exterior Painting Hockessin DE",
      "Jenc Quality Pro Painting LLC",
    ],
    author: "Jenc Quality Pro Painting LLC",
    canonicalUrl: "https://www.jencqualitypropainting.com/",
  },
  sections: {
    header: {
      businessName: "Jenc Quality Pro Painting LLC",
    },
    sectionB: {
      heroTitle: "Excellence in Painting Services",
      heroSubtitle: "Bringing Color and Life to Your Spaces",
      learnAboutText: "Learn More",
      phoneNumber: "6147794291",
      phoneLabel: "(614) 779-4291",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/508451296/photo/painter-with-paintroller-showing-a-color-palette.jpg?s=612x612&w=0&k=20&c=PYmKvGEsrOCJr8orB24NiP1Ij161lfbBFzIIVxsToWM=", // Replace with actual
      cardData: [
        {
          title: "Interior Painting",
          description:
            "Refresh your home’s interior with precise and vibrant color applications.",
        },
        {
          title: "Chirok (Siding) Remodeling",
          description:
            "Revitalize your home's exterior with our siding remodeling service, commonly known as chirok.",
        },
        {
          title: "Commercial Projects",
          description:
            "Professional painting for offices, retail spaces, and more.",
        },
      ],
      description:
        "Jenc Quality Pro Painting LLC delivers top-notch painting services across Durham, NC and Hockessin, DE. From preparation to final touch, each project is completed with professionalism and care.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "A range of professional solutions designed to enhance, protect, and restore your property.",
      cards: [
        {
          title: "Residential Painting",
          description:
            "High-quality painting services that transform interior and exterior residential spaces with precision and care.",
          imageSrc:
            "https://media.istockphoto.com/id/155369538/photo/house-painter-with-paint-brush.jpg?s=612x612&w=0&k=20&c=B35grqCPi6Fb0UMVr8JjtgeSxuI_pgRn72z9jvTGlUc=",
          imageAlt: "Residential Painting",
        },
        {
          title: "Carpentry Solutions",
          description:
            "Skilled carpentry work for repairs, trim, molding, and custom woodwork tailored to your home.",
          imageSrc:
            "https://media.istockphoto.com/id/2216047225/photo/hand-assembling-furniture-together-using-screws-brackets-and-other-fasteners-for-construction.jpg?s=612x612&w=0&k=20&c=jFamvTNkrnHU2pl7CHLMzFEv4SGfH13ycI_13kPQh3k=", // Update if needed
          imageAlt: "Carpentry Solutions",
        },
        {
          title: "Powerwashing",
          description:
            "Thorough exterior cleaning that removes dirt, mold, and grime from driveways, siding, decks, and more.",
          imageSrc:
            "https://media.istockphoto.com/id/480889561/photo/powerwasher.jpg?s=612x612&w=0&k=20&c=Lx3hfncT6sa-LwpU4S6fpq6t_tKsSlqw-4N7kt-v2no=", // Update if needed
          imageAlt: "Powerwashing",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Drywall Repair",
        "Deck & Fence Staining",
        "Cabinet Painting",
        "Color Consultation",
      ],
    },

    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://static.wixstatic.com/media/28a044_aebd9e49aec544b1a3fde519c885ba5a~mv2.png/v1/crop/x_10,y_67,w_459,h_350/fill/w_310,h_236,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/jencquality%20logo%20(1).png", // Replace if needed
        alt: "Jenc Quality Pro Painting Team",
      },
      aboutText: [
        "Jenc Quality Pro Painting LLC is built on integrity, craftsmanship, and attention to detail.",
        "We proudly serve residential and commercial clients in both North Carolina and Delaware with consistent quality and care.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Jenc Quality Pro Painting LLC Logo",
      businessName: "Jenc Quality Pro Painting LLC",
      contact: {
        phone: "6147794291",
        phoneLabel: "(614) 779-4291",
        email: "jencqualitypropaintingllc@gmail.com",
        website: "https://www.jencqualitypropainting.com/",
        address:
          "204 Chandler Rd, Durham, NC 27703; 3 Aston Cir, Hockessin, DE 19707",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "204 Chandler Rd, Durham, NC 27703",
      googleMapsEmbedUrl:
        "https://www.google.com/maps?q=204+Chandler+Rd,+Durham,+NC+27703&output=embed",
    },
  },
};

export default config;
